import {
    deepClone
} from '@/components/form/utils/index'

const componentChild = {}
/**
 * 将./slots中的文件挂载到对象componentChild上
 * 文件名为key，对应JSON配置中的__config__.tag
 * 文件内容为value，解析JSON配置中的__slot__
 */
const slotsFiles = require.context('./slots', false, /\.js$/)
const keys = slotsFiles.keys() || []
keys.forEach(key => {
    const tag = key.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = slotsFiles(key).default
    componentChild[tag] = value
})

function vModel(dataObject, defaultValue) {
    dataObject.props.value = defaultValue

    dataObject.on.input = val => {
        this.$emit('input', val)
    }


}

function mountSlotFlies(h, confClone, children) {
    const childObjs = componentChild[confClone.__config__.tag]
    if (childObjs) {
        Object.keys(childObjs).forEach(key => {
            const childFunc = childObjs[key]
            if (confClone.__slot__ && confClone.__slot__[key]) {
                children.push(childFunc(h, confClone, key))
            }
        })
    }
}

function emitEvents(confClone) {
    ['on', 'nativeOn'].forEach(attr => {
        const eventKeyList = Object.keys(confClone[attr] || {})
        eventKeyList.forEach(key => {
            const val = confClone[attr][key]
            if (typeof val === 'string') {
                confClone[attr][key] = event => this.$emit(val, confClone)
            }
        })
    })

}

function buildDataObject(confClone, dataObject) {
    Object.keys(confClone).forEach(key => {
        const val = confClone[key]
        if (key === '__vModel__') {
            vModel.call(this, dataObject, confClone.__config__.defaultValue)
        } else if (dataObject[key]) {
            dataObject[key] = {
                ...dataObject[key],
                ...val
            }
        } else {
            dataObject.attrs[key] = val
        }
            dataObject.attrs[key] = val
    })

    // 清理属性
    clearAttrs(dataObject)
}

function clearAttrs(dataObject) {
    delete dataObject.attrs.__config__
    delete dataObject.attrs.__slot__
    delete dataObject.attrs.__methods__
}

function makeDataObject() {
    return {
        attrs: {},
        props: {},
        nativeOn: {},
        on: {},
        style: {}
    }
}

export default {
    props: {
        conf: {
            type: Object,
            required: true
        }
    },
    render(h) {
        const dataObject = makeDataObject()
        const confClone = deepClone(this.conf)
        const children = []

        // 如果slots文件夹存在与当前tag同名的文件，则执行文件中的代码
        mountSlotFlies.call(this, h, confClone, children)

        // 将字符串类型的事件，发送为消息
        emitEvents.call(this, confClone)

        
        // 将json表单配置转化为vue render可以识别的 “数据对象（dataObject）”
        buildDataObject.call(this, confClone, dataObject)



        if(this.conf.category=='upload'){
            let that=this
            let files=that.conf.__config__.defaultValue&&that.conf.__config__.defaultValue.length>0?that.conf.__config__.defaultValue:[]
            
             // 上传控件通过绑定file-list显示已经上传的文件列表
            if(files.length){
                dataObject.attrs['file-list']=files.map(r=>{
                    return{
                        name:r.name,
                        url:r.path,
                        uid:r.id
                    }
                })
            }

            // 上传
            dataObject.attrs['on-success']=function(res){
                files=files.concat(res.data)
                that.$emit('input',files)
            }
            // 删除已上传的文件
            dataObject.attrs['on-remove']=function(res){
                let del_index=files.findIndex(e=>e.id==res.uid)
                if(del_index>-1){
                    files.splice(del_index,1)
                    that.$emit('input',files)
                }
            }

        }

        return h(this.conf.__config__.tag, dataObject, children)
    }
}


// WEBPACK FOOTER //
// ./src/components/form/render/render.js